import React from 'react';
import { Card } from 'react-bootstrap';
import styles from './StatsCard.module.css';

const StatsCard = ({ title, value }) => {
  return (
    <Card className={styles.card}>
      <Card.Body>
        <div className={styles.title}>{title}</div>
        <div className={styles.value}>{value}</div>
      </Card.Body>
    </Card>
  );
};

export default StatsCard;

